export default __webpack_public_path__ + "static/media/Ak logo white.5f595ddf.svg";